export const impresionTipoPropiedad = (dataLayer, { idUsuario=null, banner, apartado }) => {
	dataLayer?.push?.({
		'event': 'banners',
		'user-id': idUsuario,
		'banner': banner,
		'apartado': apartado
	});
	return true;
}

export const clickArriendoTiposPropiedad = (dataLayer, { idUsuario=null, banner, apartado }) => {
	dataLayer?.push?.({
		'event': 'click-caluga-tipo-propiedad',
		'user-id': idUsuario,
		'banner': banner,
		'apartado': apartado
	})
}